import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConfiguracoesComponent } from './configuracoes.component';

const routes: Routes = [
  {
    path: '',
    component: ConfiguracoesComponent,
    title: 'Configurações',
    // children: [{ path: ':mode', redirectTo: '', pathMatch: 'full' }]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConfiguracoesRoutingModule {}
